"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var unflatten = function unflatten(obj) {
  var result = {}; // For each object path (property key) in the object

  Object.keys(obj).forEach(function (objectPath) {
    // Split path into component parts
    var parts = objectPath.split('.'); // Create sub-objects along path as needed

    var target = result;

    while (parts.length > 1) {
      var part = parts.shift();
      target[part] = target[part] || {};
      target = target[part];
    } // Set value at end of path


    target[parts[0]] = obj[objectPath];
  });
  return result;
};

var _default = unflatten;
exports["default"] = _default;